import {
  IconArrowNarrowRight,
  IconBorderCorners,
} from '@rossum/ui/icons/tabler';
import {
  ActivityRowLayout,
  PreviousValue,
  RowIcon,
  RowLabel,
  RowValue,
} from '../../core';

type FieldChangeRowProps = {
  label: string;
  previousValue: string | null;
  value: string | null;
  hasIndent?: boolean;
};

export const FieldChangeRow = ({
  label,
  previousValue,
  value,
  hasIndent,
}: FieldChangeRowProps) => (
  <ActivityRowLayout
    dataCy="document-history-field-row"
    hasIndent={hasIndent}
    label={<RowLabel label={label} />}
    labelIcon={<RowIcon icon={IconBorderCorners} />}
    icon={<RowIcon icon={IconArrowNarrowRight} />}
    value={<RowValue value={value} />}
    secondary={
      <PreviousValue>
        <RowValue value={previousValue} secondary />
      </PreviousValue>
    }
  />
);
